export default __webpack_public_path__ + "static/media/guna_homes_logo.09d15952.png";